module.exports = __webpack_public_path__ + "img/pdf.3ff3a197.png";